import React,{useState,useEffect} from "react";
import { Link, useNavigate } from "react-router-dom";
import { baseUrl } from "../../helper/axiosConfig";
import axios from "axios";
import MobileBottomBar from "../Layout/MobileBottomBar";


function TermsCondition() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const navigate = useNavigate();
  
  useEffect(() => {
    // Scroll to top is now handled globally in Layout component
    fetchPolicy();
  }, [navigate]);


  const fetchPolicy = async () => {
    try {
      const res = await axios.get(`${baseUrl}/about-us`);

      setTitle(res.data.data.title);
      setDescription(res.data.data.description);
    } catch (error) {
    }
  };

  return (
    <>
      <section className="modern-page-banner">
        <div className="container">
          <div className="banner-content">
            <div className="banner-icon">
              <i className="fas fa-file-contract"></i>
            </div>
            <h1 className="banner-title">Website Policies</h1>
            <p className="banner-subtitle">Terms and conditions for using Fynito</p>
          </div>
        </div>
      </section>

      <section className="modern-content-section">
        <div className="container">
          <div className="content-wrapper">
            <div className="intro-section">
              <div className="intro-card">
                <p className="intro-text">
                  These Terms govern your use of the Fynito app and its services. By accessing or using Fynito, you agree to be bound by these Terms and Conditions. If you do not agree, please discontinue using the app.
                </p>
              </div>
            </div>

            <div className="policy-section">
              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-user-check"></i>
                  </div>
                  <h5 className="section-title">1. User Obligations</h5>
                </div>
                <ul className="modern-content-list">
                  <li>You must provide accurate, complete, and up-to-date information during registration and while using the app.</li>
                  <li>You agree to maintain the confidentiality of your login credentials and are responsible for all activities under your account.</li>
                  <li>You must use the app responsibly, in compliance with all applicable laws, rules, and regulations.</li>
                  <li>You may not misuse the app for fraudulent, illegal, or unauthorized activities, including but not limited to false orders or payment disputes.</li>
                </ul>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-shipping-fast"></i>
                  </div>
                  <h5 className="section-title">2. Shipping & Delivery Policy</h5>
                </div>
                <ul className="modern-content-list">
                  <li>Orders are subject to restaurant availability and acceptance.</li>
                  <li>Delivery times are estimated and may vary due to traffic, weather, demand, or other external factors beyond our control.</li>
                  <li>Our standard delivery window is 30–60 minutes, but delays may occur.</li>
                  <li>Delivery charges (if applicable) will be displayed before checkout.</li>
                  <li>In the event of unavoidable delays, users will be notified through the app or SMS.</li>
                </ul>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-credit-card"></i>
                  </div>
                  <h5 className="section-title">3. Payments</h5>
                </div>
                <ul className="modern-content-list">
                  <li>Payments must be made in full at the time of placing an order through the available payment methods on the app.</li>
                  <li>All transactions are final and non-refundable, except as provided in our Refund & Cancellation Policy.</li>
                  <li>Fynito reserves the right to suspend or cancel orders if a payment is not successfully processed.</li>
                </ul>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-undo"></i>
                  </div>
                  <h5 className="section-title">4. Refund & Cancellation Policy</h5>
                </div>
                <ul className="modern-content-list">
                  <li>Orders once placed cannot be cancelled after restaurant confirmation.</li>
                  <li>Refunds will be processed to the original payment method within 5–7 business days.</li>
                </ul>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-shield-alt"></i>
                  </div>
                  <h5 className="section-title">5. Limitation of Liability</h5>
                </div>
                <ul className="modern-content-list">
                  <li>Fynito acts as a platform connecting users with restaurants and is not responsible for the quality, taste, or safety of food delivered.</li>
                  <li>We are not liable for delays, service failures, or losses arising due to third-party restaurants, delivery partners, or unforeseen circumstances.</li>
                  <li>To the maximum extent permitted by law, our liability shall be limited to the amount paid by you for the affected order.</li>
                </ul>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-lock"></i>
                  </div>
                  <h5 className="section-title">6. Privacy & Data Protection</h5>
                </div>
                <ul className="modern-content-list">
                  <li>Your personal information is collected and used in accordance with our Privacy Policy.</li>
                  <li>We take reasonable measures to protect your data but cannot guarantee complete security against unauthorized access.</li>
                </ul>
              </div>

              <div className="policy-card highlight-card">
                <div className="section-header">
                  <div className="section-icon warning">
                    <i className="fas fa-exclamation-triangle"></i>
                  </div>
                  <h5 className="section-title">7. Data Deletion Request</h5>
                </div>
                <ul className="modern-content-list">
                  <li>You may request deletion of your personal data by emailing us at <Link to="mailto:support@fynito.com" className="email-link">support@fynito.com</Link></li>
                  <li>Upon identity verification, we will delete your account and associated data, except where retention is required by law.</li>
                </ul>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-edit"></i>
                  </div>
                  <h5 className="section-title">8. Changes to Terms</h5>
                </div>
                <ul className="modern-content-list">
                  <li>Fynito reserves the right to update or modify these Terms at any time.</li>
                  <li>Continued use of the app after changes implies acceptance of the updated Terms.</li>
                </ul>
              </div>

              <div className="policy-card">
                <div className="section-header">
                  <div className="section-icon">
                    <i className="fas fa-phone"></i>
                  </div>
                  <h5 className="section-title">9. Contact Us</h5>
                </div>
                <div className="contact-info">
                  <p><strong>FYNITO MARKETING INDIA PRIVATE LIMITED</strong></p>
                  <p>For any questions or concerns regarding these Terms, please reach us at:</p>
                  <div className="contact-details">
                    <Link to="mailto:support@fynito.com" className="contact-email">
                      <i className="fas fa-envelope"></i>
                       support@fynito.com
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="container">
            <div dangerouslySetInnerHTML={{ __html: description }} />
        </div>  */}

        {/* Mobile Bottom Bar */}
        <MobileBottomBar />
      </section>
    </>
  );
}

export default TermsCondition;
